<template>
    <InterstatePriceForm />
</template>

<script setup>
import InterstatePriceForm from './InterstatePriceForm.vue';
</script>
